import React, { Component } from "react";
import Axios from 'axios';
import { Modal, Spinner, Table } from "reactstrap";
import moment from 'moment';
import { connect } from "react-redux";
import { add, list } from '../../store/actions';
import TextField from '../../components/Form/TextField';
import DatePicker from '../../components/Form/DatePicker';
import SelectForm from "../../components/Form/SelectForm";
import withFormik from '../../utils/withFormik';
import { getUser } from '../../utils/localstorage';
import { URL_API } from "../../shared/constants";
import { toast } from "react-toastify";


class PengaturanLinkUpdate extends Component {
  constructor() {
    super();
    this.state = {
      link_update: '',
      loading: false,
      baseUrl: process.env.REACT_APP_DOMAIN_API
    }
  }

  componentDidMount() {
    const auth = getUser()
    console.log(auth.token)
    Axios.get(`${URL_API}api/apps`,
      { headers: { "Authorization": `Bearer ${auth.token}` } }
    ).then(res => {
      console.log(res)
      if (res.status === 200) {
        this.setState({ loading: false })
        res.data.data.forEach(element => {
          if (element.name == 'link_update') {
            this.setState({ link_update: element.value })
          }
        });
      }
    })
  }

  handleSubmit = () => {
    const { link_update } = this.state
    this.setState({ loading: true })
    const formData = new FormData();
    formData.append('link_update', link_update);
    const auth = getUser()
    const post = Axios.post(`${URL_API}api/apps`, formData,
      { headers: { "Content-type": `multipart/form-data;boundary=${formData._boundary}`, "Authorization": `Bearer ${auth.token}` } }
    ).then(res => {
      if (res.status === 200) {
        this.setState({ loading: false })

        toast.success('Berhasil mengganti pengaturan maintenance')
      }
    })
  }

  handleChange(val) {

    if (!val.target.value) {
      toast.warning('Harap isi pengaturan maintenance')
    }

    this.setState({ link_update: val.target.value })
  }

  render() {
    const { loading, link_update } = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <h5 className="modal-title mt-0">Pengaturan Link Update</h5>
                <form className="form-horizontal mt-4">
                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Link Update *</label>
                    <div className="col-sm-4">
                      <TextField
                        name="link_update"
                        required
                        value={link_update}
                        placeholder="Masukkan Link Update"
                        className="form-control"
                        type="text"
                        onChange={(val) => this.handleChange(val)}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label"></label>
                    <div className="col-sm-4">
                      <button
                        disabled={link_update ? false : true}
                        type="button"
                        className="btn btn-primary"
                        onClick={() => this.handleSubmit()}
                      >
                        {loading ? <Spinner size="sm" color="light" /> : 'Simpan'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment >
    )
  }
}


export default PengaturanLinkUpdate;